module.exports = __webpack_public_path__ + "static/media/dead_or_alive.netent.342a8b7d.jpeg";